if (!customElements.get('tns-native-shell')) {
  customElements.define('tns-native-shell', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const disclosure = event.target.closest('details[open]') || this.querySelector('details[open]');
        if (!disclosure) return;
        event.preventDefault();
        disclosure.open = false;
        disclosure.querySelector(':scope > summary')?.focus();
      }, options);
      this.addEventListener('click', (event) => {
        const closeButton = event.target.closest('[data-shell-close]');
        if (!closeButton) return;
        const disclosure = closeButton.closest('details');
        disclosure.open = false;
        disclosure.querySelector(':scope > summary')?.focus();
      }, options);
      this.addEventListener('toggle', (event) => {
        if (!event.target.matches('details')) return;
        if (!event.target.open) {
          event.target.querySelectorAll('details[open]').forEach((disclosure) => { disclosure.open = false; });
          return;
        }
        this.querySelectorAll('details[open]').forEach((disclosure) => {
          if (disclosure === event.target || disclosure.contains(event.target)) return;
          if (event.target.contains(disclosure)) return;
          disclosure.open = false;
        });
      }, {...options, capture: true});
      document.addEventListener('click', (event) => {
        if (this.contains(event.target)) return;
        this.querySelectorAll('details[open]').forEach((disclosure) => { disclosure.open = false; });
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!event.relatedTarget) return;
        this.querySelectorAll('details[open]').forEach((disclosure) => {
          if (!disclosure.contains(event.relatedTarget)) disclosure.open = false;
        });
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
